import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { MANUAL_JOURNAL_ENTRY_API } from "./apiRoutes";
import axiosAuth from "@/services/axiosAuth";

interface UseGetMJEPostedListProps {
  communityId: string,
  data: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getMJEPostedList = async (communityId: string, data: any) =>
  await axiosAuth.post(`${MANUAL_JOURNAL_ENTRY_API(communityId)}/posted/list`, data);

const useGetMJEPostedList = ({
  communityId,
  data,
  queryParams,
}: UseGetMJEPostedListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["mje-posted-list"],
    queryFn: () => getMJEPostedList(communityId, data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    retry: 2,
    enabled: queryParams?.enabled,
    ...queryParams,
  });
};

export default useGetMJEPostedList;
